import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { NgxCarouselModule } from 'ngx-carousel';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { SubjectDivisionTeacherComponent } from './subject-division-teacher.component';
import { FuseWidgetModule } from '../../../../../core/components/widget/widget.module';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { SubjectDivisionTeacherService } from '../../../../services/subject-division-teachers/subject-division-teacher.service';
import {AddEditSubjectTeacherComponent} from 'app/main/content/pages/management/subject-division-teacher/components/add-subject-teacher/add-edit-subject-teacher.component';

const routes = [
    {
        path: 'pages/management/subjectdivisionteacher/:id',
        component: SubjectDivisionTeacherComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_HOME',
                redirectTo: '/pages/errors/error-403'
            },
            mode : 'view'
        }
    }
];

@NgModule({
    declarations: [
        SubjectDivisionTeacherComponent,
        AddEditSubjectTeacherComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        AgmCoreModule,
        AgmSnazzyInfoWindowModule,
        NgxCarouselModule,
        FuseWidgetModule,
        NgxChartsModule
    ],
    exports: [
    ],
    providers: [
        SubjectDivisionTeacherService
    ],
    entryComponents: [
        AddEditSubjectTeacherComponent
    ]
})

export class SubjectDivisionTeacherModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/subject-division-teacher/subject-division-teacher.module.ts